// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var DragDrop = require("../../../reason/settings/components/dragDrop/DragDrop.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var AttachmentFormSection = require("../../common/attachments/AttachmentFormSection.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var MarkupHelpers = require("components/MarkupHelpers");
var PropertyWizardRelayPhotosAndFiles_draft_graphql = require("../../../__generated__/PropertyWizardRelayPhotosAndFiles_draft_graphql.bs.js");
var InitialUploadPrompt = require("components/NewProperty/NewPropertyAttachments/InitialUploadPrompt").default;

var convertFragment = PropertyWizardRelayPhotosAndFiles_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function add(addImages, addFiles, files) {
  var match = Belt_Array.partition(files, (function (file) {
          var contentType = file.type;
          return Attachments.Attachment.ContentType.isImage(contentType);
        }));
  var files$1 = match[1];
  var images = match[0];
  if (images.length > 0) {
    addImages(images);
  }
  if (files$1.length > 0) {
    return addFiles(files$1);
  }
  
}

function PropertyWizardRelay__PhotosAndFiles(props) {
  var match = use(props.draft);
  var draftProperty = match.draftProperty;
  var setFormState = PropertyWizardFormRelay.FormState.useUpdater();
  var imagesProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.images = Core__Option.getOr(value, []).map(function (param) {
                  var attachment = param[1];
                  return {
                          contentType: attachment.contentType,
                          fileName: attachment.fileName,
                          id: attachment.id,
                          key: attachment.key,
                          previewUrl: param[0]
                        };
                });
            return newrecord;
          })
      }, true, draftProperty.images.map(function (image) {
            return [
                    image.previewUrl,
                    {
                      id: image.id,
                      key: image.key,
                      fileName: image.fileName,
                      contentType: image.contentType
                    }
                  ];
          }), "Valid");
  var filesProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.files = Core__Option.getOr(value, []).map(function (attachment) {
                  return {
                          contentType: attachment.contentType,
                          fileName: attachment.fileName,
                          id: attachment.id,
                          key: attachment.key
                        };
                });
            return newrecord;
          })
      }, true, draftProperty.files.map(function (file) {
            return {
                    id: file.id,
                    key: file.key,
                    fileName: file.fileName,
                    contentType: file.contentType
                  };
          }), "Valid");
  var onUnsupportedFileError = Attachments.useUnsupportedFilesSystemMessage();
  var match$1 = React.useState(function () {
        return draftProperty.images.map(function (image) {
                    return {
                            previewUrl: image.previewUrl,
                            state: {
                              TAG: "Success",
                              _0: {
                                id: image.id,
                                key: image.key,
                                fileName: image.fileName,
                                contentType: image.contentType
                              }
                            }
                          };
                  });
      });
  var setImgs = match$1[1];
  var match$2 = React.useState(function () {
        return draftProperty.files.map(function (file) {
                    return {
                            previewUrl: undefined,
                            state: {
                              TAG: "Success",
                              _0: {
                                id: file.id,
                                key: file.key,
                                fileName: file.fileName,
                                contentType: file.contentType
                              }
                            }
                          };
                  });
      });
  var setFiles = match$2[1];
  var updateImages = function (images) {
    var images$1 = Core__List.toArray(images);
    var imagesReadyToSave = Core__Array.filterMap(images$1, (function (image) {
            var attachment = image.state;
            if (attachment.TAG === "Success") {
              return [
                      image.previewUrl,
                      attachment._0
                    ];
            }
            
          }));
    imagesProps.onChange(imagesReadyToSave);
    setImgs(function (param) {
          return images$1;
        });
    setFormState(function (formState) {
          formState.imagesStatus = Core__Array.filterMap(images$1, (function (image) {
                  var match = image.state;
                  switch (match.TAG) {
                    case "InProgress" :
                        return "InProgress";
                    case "Failed" :
                        return "Failed";
                    case "NotStarted" :
                    case "Success" :
                        return ;
                    
                  }
                }));
        });
  };
  var updateFiles = function (files) {
    var files$1 = Core__List.toArray(files);
    var filesReadyToSave = Core__Array.filterMap(files$1, (function (image) {
            var attachment = image.state;
            if (attachment.TAG === "Success") {
              return attachment._0;
            }
            
          }));
    filesProps.onChange(filesReadyToSave);
    setFiles(function (param) {
          return files$1;
        });
    setFormState(function (formState) {
          formState.filesStatus = Core__Array.filterMap(files$1, (function (file) {
                  var match = file.state;
                  switch (match.TAG) {
                    case "InProgress" :
                        return "InProgress";
                    case "Failed" :
                        return "Failed";
                    case "NotStarted" :
                    case "Success" :
                        return ;
                    
                  }
                }));
        });
  };
  var images = Attachments.useAttachments(updateImages, Core__List.fromArray(match$1[0]), onUnsupportedFileError);
  var files = Attachments.useAttachments(updateFiles, Core__List.fromArray(match$2[0]), onUnsupportedFileError);
  var add$1 = function (extra) {
    return add(images.add, files.add, extra);
  };
  var match$3 = images.attachments.concat(files.attachments);
  return JsxRuntime.jsx(CssGrid.Grid, {
              children: Caml_option.some(JsxRuntime.jsx(CssGrid.Cell, {
                        width: 12,
                        widthLg: 9,
                        children: Caml_option.some(JsxRuntime.jsx(MarkupHelpers.ContentBox, {
                                  children: Caml_option.some(JsxRuntime.jsx(DragDrop.DragDropContext.make, {
                                            children: JsxRuntime.jsx(DragDrop.DropArea.make, {
                                                  onChange: add$1,
                                                  children: match$3.length !== 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                          children: [
                                                            JsxRuntime.jsx(AttachmentFormSection.ImageUploadList.make, {
                                                                  onAddAttachments: add$1,
                                                                  onDeleteAttachment: images.delete,
                                                                  reorder: images.reorder,
                                                                  uploads: images.attachments
                                                                }),
                                                            JsxRuntime.jsx(AttachmentFormSection.FileUploadList.make, {
                                                                  onAddAttachments: add$1,
                                                                  onDeleteAttachment: files.delete,
                                                                  reorder: files.reorder,
                                                                  uploads: files.attachments
                                                                })
                                                          ]
                                                        }) : JsxRuntime.jsx(InitialUploadPrompt, {
                                                          onAddAttachments: add$1
                                                        })
                                                })
                                          }))
                                }))
                      }))
            });
}

var FormUtils;

var Form;

var Cell;

var Grid;

var ContentBox;

var DraftAttachment;

var make = PropertyWizardRelay__PhotosAndFiles;

exports.FormUtils = FormUtils;
exports.Form = Form;
exports.Cell = Cell;
exports.Grid = Grid;
exports.ContentBox = ContentBox;
exports.DraftAttachment = DraftAttachment;
exports.DraftFragment = DraftFragment;
exports.add = add;
exports.make = make;
/* react Not a pure module */
